/*************************************************/
/* MMENU                                         */
/*************************************************/
import Mmenu from 'mmenu-js';

export function mmenu() {
    let mobileMenu,
        mobileMenuTrigger

    const mobileMenuSelector = '#mobile-menu',
        mainContentSelector = '#mainContent';

    const init = function () {
        mobileMenu = document.querySelector(mobileMenuSelector);
        mobileMenuTrigger = document.querySelector('.mm-trigger');

        //Init mmenu
        const menu = new Mmenu(mobileMenuSelector, {
            slidingSubmenus: true,
            offCanvas: {
                use: true,
                position: "right-front"
            },
            navbar: {
                add: false
            }
        }, {
            offCanvas: {
                page: {
                    nodeType: "main",
                    selector: mainContentSelector
                }
            }
        });
        const mmenuApi = menu.API;
            mobileMenu.setAttribute('style', '');

        // Open menu
        mobileMenuTrigger.addEventListener('click', () => {
            if (mmenuApi) {
                mmenuApi.open();

                //Close menu (We need to get it after the menu is openend, otherwise it does not exist)
                document.querySelector('.mobile-menu__dismiss').addEventListener('click', e => {
                    if (mmenuApi) {
                        mmenuApi.close();
                    }
                })
            }
        });
    };

    init();
}
